// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"c3723eb7","497":"c3723eb7","737":"c3723eb7"}[chunkId] + ".chunk.css";
};